import React, { useState, useRef, useEffect } from 'react';

const SnapshotNoteEditor = React.memo(function SnapshotNoteEditor({
  snapshot,
  label,
  clickButtonToEdit,
}) {
  const [disabled, setDisabled] = useState(clickButtonToEdit === false ? false : true);
  const [value, setValue] = useState(snapshot.val() || '');
  const textareaRef = useRef(null);

  const saveToFirebase = async () => {
    await snapshot.ref.set(value);
    setDisabled(true);
  };

  // Auto-focus when entering edit mode
  useEffect(() => {
    if (!disabled && textareaRef.current) {
      const el = textareaRef.current;
      el.focus();
      // put caret at end
      const len = el.value.length;
      el.setSelectionRange(len, len);
    }
  }, [disabled]);

  return (
    <div className="input-group">
      <label>{label || snapshot.key}</label>

      {disabled ? (
        <span style={{ whiteSpace: 'pre-wrap' }}>{snapshot.val() || ''}</span>
      ) : (
        <textarea
          ref={textareaRef}
          cols={50}
          rows={5}
          className="fb-patheditor"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      )}

      {clickButtonToEdit !== false && (
        disabled
          ? <button onClick={() => setDisabled(false)}>Edit</button>
          : <button onClick={saveToFirebase}>Done</button>
      )}
    </div>
  );
});

export default SnapshotNoteEditor;